<script>
import ReviewPageV1 from './ReviewPage.v1.vue';
import ReviewPageV2 from './ReviewPage.v2.vue';
import { updateFaviconAndTitle } from '../utils/helpers';

export default {
  components: {
    ReviewPageV1,
    ReviewPageV2
  },
  data() {
    return {
      publicId: this.$route.path.split("/")[2],
      approverPublicId: this.$route.path.split("/")[3],
      curAccount: null,
      requiresPassword: false,
    };
  },
  async created() {
    const [curAccount, proofMeta] = await Promise.all([
      this.$A.ReviewService.GetCurrentProofAccountOwner(this.publicId),
      this.$A.ReviewService.GetProofMeta(this.publicId),
    ]);
    this.requiresPassword = !!_.get(proofMeta, "requiresPassword", false);
    this.curAccount = curAccount;
    if (this.curAccount && this.curAccount.whiteLabelEnabled && this.curAccount.whiteLabelLogoUri) {
      updateFaviconAndTitle({
        accountLogo: this.curAccount.whiteLabelLogoUri,
        accountTitle: this.curAccount.name,
      });
    }
  },
  computed: {
    version: function () {
      if (!this.curAccount) return -1;
      const screenTheme = _.get(this.curAccount, "themeSettings.reviewScreenTheme", 0);
      return `${screenTheme}` === '10' ? 2 : 1;
    },
  },
  watch: {},
};
</script>

<template>
  <div>
    <review-page-v1
        v-if="version===1"
        :public-id="publicId"
        :approver-public-id="approverPublicId"
        :cur-account="curAccount"
        :requires-password="requiresPassword"
    />
    <review-page-v2
        v-if="version===2"
        :public-id="publicId"
        :approver-public-id="approverPublicId"
        :cur-account="curAccount"
        :requires-password="requiresPassword"
    />
  </div>
</template>